import DialogModal from '../dialog-base/base';

document.addEventListener('DOMContentLoaded', () => {
    const settingModal = {
        callbackByOpen: (event) => {
            let targetButton = event.target;

            const productNameInput = document.querySelector('#product-name');
            const product = targetButton.closest('.product-detail, .product-card');

            const productName = product.querySelector('.product-detail__title, .product-card__name');

            if (productNameInput && productName) {
                productNameInput.value = productName.textContent;
            }
        },
    };

    new DialogModal({
        dialogSelector: '#productSubscribeForm',
        dialogOpenTrigger: '[data-entity="subscribe-trigger"]',
        settings: settingModal,
    });
});
